module.exports = __webpack_public_path__ + "img/logo-footer-4.e9bc0384.png";